import axios from "axios";
import {
    GET_ALL_SERVICES,
  GET_FILTER_TICKETS,
    UPDATE_DATA
} from "./types";
import { toast } from 'react-toastify';
const keys = require("../config/keys");


export const getAllServices = (data) => async (dispatch) => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/service/getallservices",
    data: data,
  })
    .then((res) => {
      if (res.data) {
        try {
          dispatch({ type: GET_ALL_SERVICES, payload: res.data.data });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch((e) => {
      console.log("catch error", JSON.stringify(e));
    });
};


export const GetFilterTickets = (ServiceId) => async (dispatch) => {
  await axios({
    method: "get",
      url: keys.ServicePath + "/api/service/get_filter_ticket_by_service_id?ServiceId=" + ServiceId
  })
    .then((res) => {
      if (res.data) {
        try {
          dispatch({ type: GET_FILTER_TICKETS, payload: res.data.service_requests });
          
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch((e) => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const ticketInsert = (data, nodeId) => async dispatch => {
  await axios({
    method: "post",
    url: keys.ServicePath + "/api/service/request_service",
    data: data
  })
    .then(res => {
      if (res.data.success) {
        try {
          const msg = {
            event: "success",
            action: data.Id === 0 ? "add" : "edit",
            page: "ticketManage",
            nodeId: nodeId || 0,
            data: res.data.data,
            success: true
          };
          toast.success('Ticket generate sucessfully', {
position: "top-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: false,
pauseOnHover: false,
draggable: false,
progress: undefined,
});
          // console.log('msg--------',msg);
          dispatch({ type: UPDATE_DATA, payload: msg });
          // notification("success", "exammaster", "save sucessfully");
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};